import Text from '@/components/Text';
import useData from '@/state/use-data';
import { AppointmentV2, ReactChildren } from '@/utils/types';
import { Link } from 'react-router-dom';

/**
 * Toast for in-person appointment confirmations.
 * Shows special message for a patient's first time booking an in-person appointment; otherwise uses the fallback.
 * @param fallback Function that returns toast content if not first in-person or on data error.
 */
export const InPersonAppointmentConfirmationToast = ({
  fallback,
}: {
  fallback: () => ReactChildren;
}) => {
  const { data, WithData } = useData(['appointments_v2']);

  return (
    <WithData data={data} renderError={fallback}>
      {({ appointments_v2: appointments }) =>
        // Relying on recent appointments to see if it's the first in-person booking. Appointment data has window of 2-3 months back and 6 months ahead.
        isFirstInPersonBooking(appointments.rows) ? (
          <Text.P.Inline>
            <Text.P.Inline.Bold>Appointment Booked!</Text.P.Inline.Bold> We'll
            share your updated <Link to="/insurance">coverage details</Link>{' '}
            before your visit.
          </Text.P.Inline>
        ) : (
          fallback()
        )
      }
    </WithData>
  );
};

const isFirstInPersonBooking = (appointments: AppointmentV2[]) => {
  const hasBookedInPersonBefore = appointments.some(
    (appointment) => appointment.location === 'in_person',
  );
  return !hasBookedInPersonBefore;
};
